import { type MutationHookOptions, useMutation } from "@apollo/client";
import { RetryEventCancelMutation } from "../graphql/mutations";
import type {
  RetryEventCancelMutationType,
  RetryEventCancelMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useRetryEventCancelMutation = (
  options?: MutationHookOptions<
    RetryEventCancelMutationType,
    RetryEventCancelMutationVariablesType
  >
) =>
  useMutation<
    RetryEventCancelMutationType,
    RetryEventCancelMutationVariablesType
  >(RetryEventCancelMutation, options);
